import { Channel, CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

const description = "Bills Dashboard";
const title = "View my bills";

export const paymentDashboard: IMcAppType = {
  name: "paymentDashboard_SAP",
  path: "/my-account/pay-bill",
  description,
  navFlow: NavFlow.STANDARD,
  parent: Tab.MORE,
  title,
  conditions: {
    intent: "paymentDashboard",
    channel: Channel.NATIVE,
    customerType: CustomerType.sap,
  },
};

export const paymentDashboard_WEB: IMcAppType = {
  name: "paymentDashboard_WEB",
  path: "/my-account/home/billing-payments/view-my-bills.html",
  description,
  navFlow: NavFlow.EXTERNAL_AUTH,
  parent: Tab.MORE,
  title,
  conditions: {
    intent: "paymentDashboard",
    channel: Channel.WEB,
    customerType: CustomerType.sap,
  },
};
